<template>
  <div>
    <Can I="delete" a="/meslek-birligi/MB">
      <b-modal
      id="modal-meslekbirligi-delete"
      centered
      title="Meslek Birliği Sil"
      ok-title="Sil"
      ok-variant="danger"
      header-bg-variant="danger"
      header-text-variant="white"
      cancel-title="İptal"
      cancel-variant="outline-secondary"
      @ok.prevent="remove"
      :busy="overlay">
        <p>{{ getMessage(332) }}</p>
      </b-modal>
    </Can>
    <Can I="read" a="/meslek-birligi/MBLog">
      <b-modal
        id="modal-log"
        size="lg"
        centered
        title="Loglar"
        ok-variant="secondary"
        ok-title="Kapat"
        ok-only
        :busy="$store.state.general.showOverlay"
        @hidden="clearLogForm">
        <div>
          <form>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group">
                  <label>Meslek Birliği</label>
                  <select v-select
                      class="form-control"
                      v-model="logForm.mbId">
                    <option :value="0">Seçiniz</option>
                    <option :value="item.id"
                        v-for="(item,index) in mblist"
                        :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group">
                    <label>Kullanıcı Adı</label>
                    <input type="text" class="form-control" v-model="logForm.userName" maxlength="64">
                </div>
              </div>
              <div class="col-sm-2">
                <button class="btn btn-block btn-outline-secondary mt-4" type="button" @click="getLogModal">Listele</button>
              </div>
            </div>
          </form>
          <div class="table-responsive" style="max-height:500px;">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>İşlem Tarihi</th>
                    <th class="fit">Meslek Birliği Id</th>
                    <th class="fit">İşlem</th>
                    <th class="fit">Kolon Adı</th>
                    <th class="fit">Tablo Adı</th>
                    <th>Eski Değer</th>
                    <th>Yeni Değer</th>
                    <th class="fit">Kullanıcı Adı</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in log.liste" :key="index"  class="cursor-pointer">
                    <td>{{ item.modTime | moment("DD/MM/YYYY") }}</td>
                    <td class="fit">{{ item.eserID }}</td>
                    <td class="fit">{{ getLogAction(item.action) }}</td>
                    <td class="fit">{{ item.columnName }}</td>
                    <td class="fit">{{ item.tableName }}</td>
                    <td>{{ item.oldValue }}</td>
                    <td>{{ item.newValue }}</td>
                    <td class="fit">{{ item.userName }}</td>
                  </tr>
                </tbody>
              </table>
          </div>
          <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
          <div class="row" v-if="log.liste.length > 0">
            <div class="col">
              <i class="text-secondary">{{ log.sayfalama.totalItems }} kayıttan {{ ((logForm.pageNum - 1) * logForm.pageSize) + 1 }} - {{ logForm.pageNum * logForm.pageSize }} arası gösterilmektedir</i>
            </div>
            <div class="col">
              <div class="row">
                <div class="col d-flex justify-content-end">
                  <nav>
                    <paginate v-if="log.liste.length"
                              :page-count="log.sayfalama.totalPages"
                              :click-handler="changeLogPage"
                              :prev-text="'Önceki'"
                              :next-text="'Sonraki'"
                              :active-class="'active'"
                              :container-class="'pagination'"
                              v-model="logForm.pageNum">
                    </paginate>
                  </nav>
                </div>
                <div class="col-2">
                  <select v-select class="form-control" v-model="logForm.pageSize" @change="changeLogSize">
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </Can>
    <div class="standart-page">
      <div class="row">
        <div class="col"></div>
        <div class="col"><h3 class="title">MESLEK BİRLİKLERİ</h3></div>
        <div class="col d-flex justify-content-end align-items-start">
          <Can I="create" a="/meslek-birligi/MB">
            <button class="btn btn-danger" @click="$router.push('meslek-birligi/detay')"><font-awesome-icon icon="plus" size="lg"></font-awesome-icon> Yeni Meslek Birliği</button>
          </Can>
        </div>
      </div>
      <div class="card-component mb-5">
        <div class="body">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                    <label>Unvan</label>
                    <input type="text" class="form-control" v-model="form.unvani" maxlength="128">
                </div>
              </div>
              <div class="col-sm-4">
                  <div class="form-group">
                      <label>Faaliyet Sektörü</label>
                      <select v-select class="form-control" v-model="form.faaliyetSektoru">
                          <option :value="0">Seçiniz</option>
                          <option :value="item.id"
                                  v-for="(item,index) in $store.state.general.parameters.faaliyetSektoru" :key="index">
                                  {{ item.name }}
                          </option>
                      </select>
                  </div>
              </div>
              <div class="col-sm-4">
                  <div class="form-group">
                      <label>Faaliyet Alanı</label>
                      <select v-select class="form-control" v-model="form.faaliyetAlani">
                          <option :value="0">Seçiniz</option>
                          <option :value="item.id"
                                  v-for="(item,index) in $store.state.general.parameters.faaliyetAlani" :key="index">
                                  {{ item.name }}
                          </option>
                      </select>
                  </div>
              </div>
            </div>
        </div>
        <div class="footer d-flex justify-content-end">
          <Can I="read" a="/meslek-birligi/MBLog">
            <button class="btn btn-outline-secondary mt-4" v-b-modal.modal-log>Log</button>
          </Can>
          <button class="btn btn-outline-secondary mt-4" @click="clear">Temizle</button>
          <button class="btn btn-secondary mt-4" @click="search">Listele</button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Resmi Unvan</th>
              <th class="fit">Kısa Unvan</th>
              <th class="fit">Faaliyet Alanı</th>
              <th class="fit">Faaliyet Sektörü</th>
              <th class="fit text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in $store.state.mb.meslekBirligi.liste" :key="index" class="cursor-pointer" @click="$router.push('/meslek-birligi/detay/' + item.recordId)">
              <td>{{ item.resmiUnvan }}</td>
              <td class="fit">{{ item.kisaUnvan }}</td>
              <td class="fit">{{ getOptionWithParams(item.faaliyetAlani, "faaliyetAlani") }}</td>
              <td class="fit">{{ getOptionWithParams(item.faaliyetSektoru, "faaliyetSektoru") }}</td>
              <td class="fit text-right">
                  <Can I="delete" a="/meslek-birligi/MB">
                      <button class="btn btn-sm btn-outline-secondary" @click.stop="showDeleteModal(item)">
                          <font-awesome-icon icon="trash-alt" size="lg"></font-awesome-icon>
                      </button>
                  </Can>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
      <div class="row" v-if="$store.state.mb.meslekBirligi.liste.length > 0 && !showError">
        <div class="col">
          <i class="text-secondary">{{ $store.state.mb.meslekBirligi.sayfalama.totalItems }} kayıttan {{ ((form.pageNum - 1) * form.pageSize) + 1 }} - {{ form.pageNum * form.pageSize }} arası gösterilmektedir</i>
        </div>
        <div class="col">
          <div class="row">
            <div class="col d-flex justify-content-end">
              <nav>
                <paginate v-if="$store.state.mb.meslekBirligi.liste.length"
                          :page-count="$store.state.mb.meslekBirligi.sayfalama.totalPages"
                          :click-handler="changePage"
                          :prev-text="'Önceki'"
                          :next-text="'Sonraki'"
                          :active-class="'active'"
                          :container-class="'pagination'"
                          v-model="form.pageNum">
                </paginate>
              </nav>
            </div>
            <div class="col-2">
              <select class="form-control" v-model="form.pageSize" @change="changeSize">
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      prevRoute:null,
      errorMessage:'',
      showError: false,
      overlay: false,
      mblist:[],
      form: {
        unvani: "",
        faaliyetSektoru:0,
        faaliyetAlani:0,
        pageNum: 1,
        pageSize: 25
      },
      log: {
        liste: [],
        sayfalama: {}
      },
      logForm:{
        mbId:0,
        userName:"",
        pageNum: 1,
        pageSize: 25
      }
    }
  },
  methods: {
    ...mapActions("general", ["showModal", "errorHandling", "fileUpload"]),
    ...mapActions('uye', ['getMBList']),
    ...mapActions('mb', ["searchMeslekBirligi", "deleteMeslekBirligi" , "importList", "getLog"]),
    clear() {
      this.$store.state.mb.meslekBirligi = Object.assign({}, {
        liste: [],
        sayfalama: {}
      });
      this.form = Object.assign({}, {
        unvani: "",
        faaliyetSektoru:0,
        faaliyetAlani:0,
        pageNum: 1,
        pageSize: 25
      });
      this.$store.state.mb.duplicateForm = Object.assign({}, this.form);
      this.showError = false;
      this.$store.state.mb.searchList = false;
    },
    changeSize() {
      this.list();
    },
    changePage(pageNumber) {
      this.form.pageNum = pageNumber;
      this.list();
    },
    search(){
      this.form.pageNum = 1;
      this.list();
    },
    list() {
      this.$store.state.mb.meslekBirligi.liste = [];

      if (this.isEmptyFilterForm()) {
        this.showError = true;
        this.errorMessage = this.getMessage(140);
        return;
      }

      this.$store.state.mb.duplicateForm = Object.assign({}, this.form);
      this.$store.state.general.showOverlay = true;
      this.showError = false;
      this.searchMeslekBirligi(this.form).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
          this.$store.state.mb.searchList = true;
        }else{
          this.$store.state.mb.searchList = true;
          this.showError = false;
          this.errorMessage = "";
        }
      }).catch((err) => {
        this.showModal({title: 'Hata!', message: err, type: 'danger'});
        this.$store.state.general.showOverlay = false;
      });
    },
    isEmptyFilterForm() {
      this.formTrimCheck(this.form);
      return this.form.faaliyetSektoru === 0
        && this.form.faaliyetAlani === 0
        && this.form.unvani === '';
    },
    showDeleteModal(item) {
      this.$store.state.mb.removeItem = item;
      this.$bvModal.show('modal-meslekbirligi-delete');
    },
    remove() {
      this.$store.state.general.showOverlay = true;
      this.deleteMeslekBirligi(this.$store.state.mb.removeItem.recordId).then((res) => {
        this.$store.state.general.showOverlay = false;
        this.$bvModal.hide('modal-meslekbirligi-delete');
        if(res.errorCode == 0){
          this.list();
        }else{
          this.errorHandling(res);
        }
      }).catch((err) => {
        this.showModal({title: 'Hata!', message: err, type: 'danger'});
        this.$store.state.general.showOverlay = false;
      });
    },
    getMBListOptions(){
      this.$store.state.general.showOverlay = true;
      this.getMBList().then(res => {
        if(res.errorCode == 0){
            this.mblist = res.data;
        }else{
            this.errorHandling(res);
        }
        this.$store.state.general.showOverlay = false;
      });
    },
    getLogModal(){
      if(this.logForm.mbId == 0)
        return;
        
      this.log.liste = [];
      this.getLog(this.logForm).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
        }else{
          this.log = res.data;

          this.showError = false;
          this.errorMessage = "";
        }
      }).catch(() => {
        this.$store.state.general.showOverlay = false;
      });
    },
    changeLogPage(pageNumber) {
      this.logForm.pageNum = pageNumber;
      this.getLogModal();
    },
    changeLogSize() {
      this.logForm.pageNum = 1;
      this.getLogModal();
    },
    clearLogForm(){
      this.log.liste = [];
      this.logForm.userName = "";
      this.logForm.mbId = 1;
    },
    init(){
      this.getMBListOptions();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created() {
    this.init();
  },
  watch: {
    prevRoute(nw) {
      if (nw.name === 'meslek-birligi-detay' || nw.name === 'meslek-birligi-detay-id') {
        if (Object.keys(this.$store.state.mb.duplicateForm).length > 0) {
          this.form = Object.assign({}, this.$store.state.mb.duplicateForm);
          if(this.$store.state.mb.searchList){
            this.list();
          }
        }
      } else {
        this.clear();
      }
    }
  },
  computed: {
    ...mapGetters('general', ['getMessage', 'getOptionWithParams', 'getLogAction', 'formTrimCheck'])
  }
};
</script>